export enum ZIndex {
    Table = 100,
    Controls,
    Dropdown,
    Tooltip,
    Modal,
}
